"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentsLibraries = exports.getComponentsLibrariesFromURL = void 0;
const getComponentsLibrariesFromURL_1 = require("./getComponentsLibrariesFromURL");
Object.defineProperty(exports, "getComponentsLibrariesFromURL", { enumerable: true, get: function () { return getComponentsLibrariesFromURL_1.getComponentsLibrariesFromURL; } });
/**
 * This is a temp source of truth until a better alternative is supplied via DevCenter or something similar
 */
const oldWhitelist = [
    {
        artifactId: 'editor-elements',
        namespace: 'wixui',
    },
    {
        artifactId: 'editor-elements',
        namespace: 'dsgnsys',
    },
];
const newWhitelist = [
    {
        artifactId: 'editor-elements-library',
        namespace: 'wixui',
    },
    {
        artifactId: 'editor-elements-design-systems',
        namespace: 'dsgnsys',
    },
];
/**
 * Will return list of components libraries with actual urls to each one of them.
 * In case when "serviceTopology" is not provided a whitelist of libraries
 * without urls will be returned
 */
const getComponentsLibraries = (serviceTopology, url, prefix, shouldUseNewWhitelist = false) => {
    const urlLibraries = [];
    if (url) {
        urlLibraries.push(...(0, getComponentsLibrariesFromURL_1.getComponentsLibrariesFromURL)(url, prefix));
    }
    if (!serviceTopology) {
        return [...urlLibraries];
    }
    const whitelist = shouldUseNewWhitelist ? newWhitelist : oldWhitelist;
    const topologyLibraries = whitelist.reduce((acc, lib) => {
        const { artifactId } = lib;
        const libraryEntryInTopology = serviceTopology[artifactId] ||
            serviceTopology.scriptsLocationMap[artifactId];
        if (typeof libraryEntryInTopology === 'string') {
            acc.push(Object.assign(Object.assign({}, lib), { url: libraryEntryInTopology }));
        }
        return acc;
    }, []);
    return [...topologyLibraries, ...urlLibraries];
};
exports.getComponentsLibraries = getComponentsLibraries;
//# sourceMappingURL=getComponentsLibraries.js.map